import { useEffect, useMemo, useState } from "react"
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import { useFilter } from "../../../context/FIlterContext";
import _ from "underscore";

export const useTaskStatusSummary = () => {
    const { projectFilter, setProjectFilter } = useFilter();
    const [taskStatus, setTaskStatus] = useState(null)
    useEffect(() => {
        projectFilter?.apiCall && getProjectTaskStatusSummaryData();
    }, [projectFilter?.apiCall])

    const getProjectTaskStatusSummaryData = async () => {
        try {
            const payload = {
                client_id: projectFilter?.client_id?.client_id || 0,
                project_ids: _.pluck(projectFilter?.project_ids, 'project_id')?.toString(),
                lead_user_code: projectFilter?.lead_user_code?.user_code || 0,
                request_user_code: projectFilter?.request_user_code || 0,
                project_module_ids: _.pluck(projectFilter?.project_module_ids, 'option_id')?.toString(),
                feature_ids: _.pluck(projectFilter.feature_ids, 'issue_id')?.toString(),
                issue_key: projectFilter?.issue_id,
            };
            const res = await services.getInvokeRemote('POST', Urls('GETPROJECTTASKSTATUSSUMMARY'), payload);
            const taskData = res?.body?.data?.project_task_status_summary || [];
            if (!Array.isArray(taskData)) {
                setTaskStatus([]);
                setProjectFilter(prev => ({ ...prev, apiCall: false }));
                return;
            }
            var totalData = _.reduce(
                _.pluck(taskData, 'total_issues'),
                (sum, num) => sum + num,
                0
            );
            const sortedArray = taskData.sort((a, b) => a.display_order - b.display_order);
            const mappedArray = sortedArray.map((item, idx, arr) => {
                let style = { backgroundColor: item.status_color_code };
                if (idx === 0) {
                    style.borderTopLeftRadius = "5px";
                    style.borderBottomLeftRadius = "5px";
                }
                if (idx === arr.length - 1) {
                    style.borderTopRightRadius = "5px";
                    style.borderBottomRightRadius = "5px";
                }
                return {
                    name: item.status_category,
                    count: item.total_issues,
                    style,
                    width: `${(item.total_issues / totalData * 100)?.toFixed(2)}%`
                };
            });

            setTaskStatus(mappedArray);
            setProjectFilter(prev => ({ ...prev, apiCall: false }));
        } catch (error) {
            console.error('Error:', error);
            setTaskStatus([]);
            setProjectFilter(prev => ({ ...prev, apiCall: false }));
        }
    };

    return useMemo(() => ({
        taskStatus
    }), [taskStatus])
}